export const DATE_NOW = new Date().getTime();
export const CACHEBUSTER = _CACHEBUSTER;
